import React from 'react';
import { OptionButton } from 'AppSrc/core/components/utility/option-button';
import {
  EXPEDITED_FIXED,
  NORMAL_FIXED,
  EXPEDITED_MOBILE,
  NORMAL_MOBILE,
  NO_IMPACT_MOBILE,
  NO_IMPACT_FIXED,
  EMERGENCY_FIXED,
  EMERGENCY_MOBILE,
  STANDARD_FIXED,
  STANDARD_MOBILE,
} from 'AppSrc/core/components/forms/value-dependency-constants';
import {
  CheckBoxUnchecked,
  CheckBoxChecked,
} from 'AppSrc/core/components/common/svg-icons';
import PropTypes from 'prop-types';

const SLA_FILTER_OPTIONS = [
  {
    id: 'emergency',
    text: 'Emergency',
    values: [EMERGENCY_FIXED, EMERGENCY_MOBILE],
  },
  {
    id: 'standard',
    text: 'Standard',
    values: [STANDARD_FIXED, STANDARD_MOBILE],
  },
  {
    id: 'noImpact',
    text: 'No impact',
    values: [NO_IMPACT_FIXED, NO_IMPACT_MOBILE],
  },
  {
    id: 'expedited',
    text: 'Expedited',
    values: [EXPEDITED_FIXED, EXPEDITED_MOBILE],
  },
  {
    id: 'normal',
    text: 'Normal',
    values: [NORMAL_FIXED, NORMAL_MOBILE],
  },
];

const CrqListSlaFilter = ({
  selectedSlas,
  toggleSla,
}) => (
  <div className="crq-list-checkbox-filter crq-list-sla-filter">
    <h3>Change SLA</h3>
    <ul>
      {SLA_FILTER_OPTIONS.map(({ id, text }) => {
        const isSelected = selectedSlas.includes(id);
        return (
          <li key={id}>
            <OptionButton
              className={`checkbox-option ${isSelected ? 'checkbox-option-selected' : ''}`}
              onClick={toggleSla}
              option={id}
            >
              <div className="svg-container">
                {isSelected ? <CheckBoxChecked /> : <CheckBoxUnchecked />}
              </div>
              {text}
            </OptionButton>
          </li>
        );
      })}
    </ul>
  </div>
);

CrqListSlaFilter.propTypes = {
  selectedSlas: PropTypes.arrayOf(PropTypes.string),
  toggleSla: PropTypes.func,
};

export { CrqListSlaFilter, SLA_FILTER_OPTIONS };
